module.exports = __webpack_public_path__ + "static/fcra-2020-21-q3-606eadb4eecb80ca6ce62051e102f2c7.pdf";